export enum GcCertifyActions {
  Add = 'add',
  Remove = 'remove',
  Update = 'update',
  None = 'none'
}

export enum NotificationType {
  Info = 'info',
  Warning = 'warn',
  Error = 'error',
  Critical = 'critical',
  RemoveVendorRequest = 'Remove Vendor Request',
  CertifySubListRequest = 'Certify Sub List Request'
}

export enum PermissionLevelEnum {
  Admin = 'admin',
  Standard = 'standard',
  Read = 'readonly'
}